import {
  OmsOrderNotesConditionStep,
  OmsStreetAddressConditionStep,
} from "@redotech/redo-model/advanced-flow/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-model/advanced-flow/steps";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo } from "react";
import { DeepPartial } from "..";

export const TextInput = memo(function TextInput({
  step,
  setStep,
}: {
  step:
    | DeepPartial<OmsStreetAddressConditionStep>
    | DeepPartial<OmsOrderNotesConditionStep>;
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
}) {
  return (
    <RedoTextInput
      setValue={(value) => setStep({ ...step, matchValue: value })}
      value={step.matchValue || ""}
    />
  );
});
